import styled from 'styled-components';
import {Link as RouterLink} from '../Link';

export const CleanLink = styled(RouterLink)`
  all: unset;
  cursor: pointer;
`;
